import { Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@utils/api';
import { formatInboxTime } from '@utils/helpers';
import { useNotifications } from '@context/NotificationContext';
import { INBOX_READ_ROW, INBOX_ROW_FRAME, INBOX_UNREAD_ROW } from '@components/messages/inboxRowStyles';

const PhotoFollowupInboxCard = ({ n, onFollowupRead, isPulsing = false }) => {
  const navigate = useNavigate();
  const { refreshUnreadCount } = useNotifications();
  const activityTitle = n.activityId?.title || 'Vibe';
  const activityNavId = n.activityId?._id ?? n.activityId;
  const notifId = n._id ?? n.id;

  const handleClick = async () => {
    try {
      if (!n.isRead && notifId) {
        await api.patch(`/notifications/${notifId}/read`);
        await onFollowupRead?.(notifId);
      }
    } catch {
      /* still navigate */
    }
    await refreshUnreadCount();
    if (activityNavId) {
      navigate(`/activity/${activityNavId}#memory`);
    }
  };

  const unread = !n.isRead;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${INBOX_ROW_FRAME} ${unread ? INBOX_UNREAD_ROW : INBOX_READ_ROW} ${
        isPulsing ? 'animate-pulse-glow' : ''
      }`}
    >
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal-100 dark:bg-teal-500/20">
        <Camera className="text-teal-700 dark:text-teal-300" size={22} strokeWidth={1.8} aria-hidden />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <p className="font-semibold text-surface-900 dark:text-surface-50">
            <span className="text-teal-800 dark:text-teal-300">After your vibe</span>
            <span className="mx-1.5 font-normal text-surface-400 dark:text-surface-500">·</span>
            <span className="font-medium text-surface-800 dark:text-surface-200">{activityTitle}</span>
          </p>
          <span className="shrink-0 text-xs text-surface-400">{formatInboxTime(n.createdAt)}</span>
        </div>
        <p className="mt-1 text-sm text-surface-500 dark:text-surface-400">
          {n.message?.trim() || 'Let us know if it happened—and share a photo if you like.'}
        </p>
      </div>
    </button>
  );
};

export default PhotoFollowupInboxCard;
